/**************************************************
 * Nombre:       Apartado_Pasos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarejeta_Paso from "../Tarjeta/Tarejeta_Paso";

const Apartado_Pasos = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{
                                fontSize: 24,
                                fontWeight: 700,
                                color: '#1B0B3B',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                lineHeight: 1.3
                            }}>
                                {item.tituloPasos}
                                <br/>
                                <span
                                    style={{color: '#9049F5'}}> {item.rosadoTituloPasos}</span>
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={8}
                            sx={{mt: 10}}
                        >

                            {item && item.pasos && item.pasos.map((it, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarejeta_Paso item={it} />
                                </Grid>
                            ))}

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Apartado_Pasos

const item = [1, 2]